import { render, staticRenderFns } from "./yearly-inflation-table.vue?vue&type=template&id=9932e402&scoped=true"
import script from "./yearly-inflation-table.vue?vue&type=script&lang=ts"
export * from "./yearly-inflation-table.vue?vue&type=script&lang=ts"
import style0 from "./yearly-inflation-table.vue?vue&type=style&index=0&id=9932e402&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9932e402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9932e402')) {
      api.createRecord('9932e402', component.options)
    } else {
      api.reload('9932e402', component.options)
    }
    module.hot.accept("./yearly-inflation-table.vue?vue&type=template&id=9932e402&scoped=true", function () {
      api.rerender('9932e402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inflation-step/yearly-inflation-table/yearly-inflation-table.vue"
export default component.exports